import {
  Audience,
  Audience_values as audienceValues,
  SupportEntryPointEntryPoint,
  SupportEntryPointEntryPoint_values as entryPointValues,
  SupportTriggerPointTriggerPoint,
  SupportTriggerPointTriggerPoint_values as triggerPointValues,
} from '../generated/types';

const audiences = new Set<string>(audienceValues);
const entryPoints = new Set<string>(entryPointValues);
const triggerPoints = new Set<string>(triggerPointValues);

export function isValidAudience(value: string): value is Audience {
  return audiences.has(value);
}

export function isValidEntryPoint(
  value: string,
): value is SupportEntryPointEntryPoint {
  return entryPoints.has(value);
}

export function isValidTriggerPoint(
  value: string,
): value is SupportTriggerPointTriggerPoint {
  return triggerPoints.has(value);
}
